__webpack_require__.p = "/souq-abnoud/";